import { useContext, useEffect } from "react";
import { ContextAuth } from "../../context";
import { ContextNav } from "../../context/ContextNav";
import { CSvgPlusCircle, CSvgFilter, CSvgArrowRight, CSvgList, CSvgCalender } from "../CSvg";
import { Link, useNavigate } from "react-router-dom";
import DatePicker from "react-multi-date-picker"

interface IProps {
    title: string,
    isCalender?: boolean,
    isAdd?: boolean,
    isFilter?: boolean,
    onClickFilter?: () => void,
    onClickAdd?: () => void,
    onClickCalender?: () => void,
}


export const NavBar = ({ title, isAdd, isCalender, isFilter, onClickFilter, onClickAdd, onClickCalender }: IProps) => {
    const CtxNav = useContext(ContextNav)
    const navigate = useNavigate()

    return (
        <>
            <div className='w-full h-[50px] shadow px-[20px] flex items-center justify-between'>
                <div className='flex items-center'>
                    <CSvgList onClick={() => { CtxNav.setdisplayMenu(true) }} className='fill-dayan-orange-50 w-[30px] cursor-pointer' />
                    <span className='text-dayan-orange-50 mr-3'>{title}</span>
                </div>
                <div className='flex items-center'>
                    {isFilter == true &&
                        <div onClick={() => onClickFilter?.()} className='w-[30px] h-[30px]  mx-1 flex items-center justify-center cursor-pointer'>
                            <CSvgFilter className=' w-[20px]  ' />
                        </div>
                    }
                    {isAdd == true &&
                        <div onClick={() => onClickAdd?.()} className='w-[30px] h-[30px]  mx-1 flex items-center justify-center cursor-pointer'>
                            <CSvgPlusCircle className='fill-dayan-orange-50 w-[20px]  ' />
                        </div>
                    }
                    {isCalender == true &&
                        <div onClick={() => onClickCalender?.()} className='w-[30px] h-[30px]  mx-1 flex items-center justify-center cursor-pointer'>
                            <CSvgCalender className='fill-dayan-orange-50 w-[20px]  ' />
                        </div>
                    }
                    <div onClick={() => { navigate('/p/record') }} className='w-[30px] h-[30px]  mr-1 flex items-center justify-center cursor-pointer'>
                        <CSvgArrowRight className='fill-dayan-orange-50 w-[20px] rotate-180  ' />
                    </div>
                </div>
            </div>
        </>
    );
}


//@ts-ignore
export function CustomInput({ openCalendar }: any) {
    return (
        <label>
            <CSvgCalender className='fill-dayan-orange-50 w-[20px]  ' />
            <input onFocus={openCalendar} className='border' />
        </label>
    )
}

